import { render } from "./SchedaAttivita.vue?vue&type=template&id=61495497"
import script from "./SchedaAttivita.vue?vue&type=script&lang=js"
export * from "./SchedaAttivita.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__